module.exports = __webpack_public_path__ + "static/media/lekse-k.0ebe76b1.mp3";